import { ChangeDetectionStrategy, Component, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { InfoBarBaseComponent } from '../info-bar-base.component';
import { MatIcon } from '@angular/material/icon';


@Component({
    selector: 'info-bar-mobile',
    templateUrl: './info-bar-mobile.component.html',
    styleUrls: ['./info-bar-mobile.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatIcon],
})
export class InfoBarMobileComponent extends InfoBarBaseComponent {
  showFullScreenVideo = false;


  @ViewChild('headerVideo', { static: false }) headerVideo: ElementRef;

  constructor() {
    super();
  }

  openFullscreen(): void {
    const video: any = this.headerVideo.nativeElement;
    if (!this.showFullScreenVideo) {
      video.pause();
      this.showFullScreenVideo = true;
      video.load();
    }

    video.currentTime = 0;
    if (video.requestFullscreen) {
      video.requestFullscreen();
    } else if (video.webkitRequestFullscreen) { /* Safari */
      video.webkitRequestFullscreen();
    } else if (video.msRequestFullscreen) { /* IE11 */
      video.msRequestFullscreen();
    }
  }
}
